import React, { useState } from "react";
import { createPortal } from "react-dom";
import "../component/modalDetailProductInvoice.css";
import { formatRupiah } from "../../../helper/formatNumber";
const ModalDetailProductInvoice = ({
  isShowModal,
  onCloseModal,
  onSubmitData,
  productObject,
}) => {
  const [productData, setProductData] = useState(productObject);
  const closeModal = () => {
    setProductData({
      product_invoice_id: "",
      product_invoice_supplier_id: "",
      product_invoice_document_number: "",
      product_invoice_date: "",
      product_invoice_due_date: "",
      product_invoice_products: [],
      product_invoice_total_discount: "",
      product_invoice_total_order: "",
      product_invoice_total_tax: "",
      product_invoice_total_netto: "",
      product_invoice_total_netto_tax: "",
    });
    onCloseModal();
  };

  // =====================
  // Request Method
  // =====================

  return createPortal(
    isShowModal && (
      <div className="modal-product-container">
        <div className="modal-product-content">
          <header className="modal-product-header">
            <h2 className="modal-product-header-title">Detail Produk</h2>
            <button className="modal-header-close-button" onClick={closeModal}>
              &times;
            </button>
          </header>
          <main className="modal-product-main">
            <div className="product-table-container">
              <table className="product-table">
                <thead>
                  <tr>
                    <th width="50px">No</th>
                    <th>Nama</th>
                    <th>Jumlah</th>
                    <th>Tanggal Kedaluwarsa</th>
                    <th>Harga Per Unit</th>
                    <th>Diskon</th>
                    <th>Total Harga</th>
                  </tr>
                </thead>
                <tbody>
                  {productData.map((product, index) => (
                    <tr
                      key={index}
                      style={{
                        color: product.is_going_expired ? "red" : "black",
                      }}
                    >
                      <td>{index + 1}</td>
                      <td>{product.product_invoice_product_name}</td>
                      <td>{product.product_invoice_product_quantity}</td>
                      <td>{product.product_invoice_product_expired_date}</td>
                      <td>
                        {formatRupiah(
                          product.product_invoice_product_price_per_unit
                        )}
                      </td>
                      <td>{product.product_invoice_product_discount} %</td>
                      <td>
                        {formatRupiah(
                          product.product_invoice_total_product_price
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </main>
          <footer className="modal-product-footer">
            <button className="modal-close-button" onClick={closeModal}>
              Tutup
            </button>
          </footer>
        </div>
      </div>
    ),
    document.getElementById("modal")
  );
};

export default ModalDetailProductInvoice;
